<template>
  <div v-if="type === 'tessere'">
    <table>
      <tr
        v-for="(tessera, index) in json"
        :key="`tessera-${index}`"
        :class="index === json.length ? 'last-child' : ''"
      >
        <td :width="editingIndex === index ? null : '100px'" style="text-align: right">
          <div v-if="editingIndex !== index" class="tessera-number-actions">
            <span :style="{ color: tessera.asdTesHexColor }">
              <b class="tessera-number">{{ tessera.asdTesNum }}</b>
            </span>
            <v-tooltip
              v-if="tessera.changeNumber && RBAC_tesseramenti_CAN_CHANGE_TES_NUMBER"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="startEdit(index, tessera)"
                >
                  <v-icon style="cursor: pointer" color="primary">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("edit_number") }}</span>
            </v-tooltip>
          </div>
          <div v-if="editingIndex === index" style="display: flex; align-items: center; white-space: nowrap">
            <v-text-field
              v-model="editValue"
              dense
              hide-details
              style="max-width: 60px"
            ></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon color="success" v-bind="attrs" v-on="on" @click="saveEdit(index, tessera)">
                  <v-icon small style="cursor: pointer" color="success">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("save") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small icon color="error" v-bind="attrs" v-on="on" @click="cancelEdit">
                  <v-icon small style="cursor: pointer" color="error">mdi-undo</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("undo") }}</span>
            </v-tooltip>
          </div>
        </td>
        <td width="50px"><img width="50px" :src="tessera.tesseraImage" /></td>
        <td>
          {{ tessera.customers.ragSoc }}
          <br /><span :style="{ color: tessera.asdTesHexColor }"
            ><b>{{ tessera.asdTesTipo }}</b></span
          >
        </td>
        <td>
          {{ $t("start_validity") }}:
          {{ new Date(tessera.dateTes).toLocaleDateString("it") }}<br />
          {{ $t("end_validity") }}:
          {{ new Date(tessera.dateEnd).toLocaleDateString("it") }}
        </td>
          
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "list-tessere-cell-component",
  props: {
    type: String,
    json: [Array, Object],
  },
  data() {
    return {
      editingIndex: null,
      editValue: null,
      RBAC_tesseramenti_CAN_CHANGE_TES_NUMBER: false,
    };
  },
  watch: {},
  mounted() {
    // Initialize RBAC flag or any other setup if needed
    this.RBAC_tesseramenti_CAN_CHANGE_TES_NUMBER = this.checkUserRole("tesseramenti", "CAN_CHANGE_TES_NUMBER");
  },  
  methods: {
    startEdit(index, tessera) {
      this.editingIndex = index;
      this.editValue = tessera.asdTesNum;
    },
    cancelEdit() {
      this.editingIndex = null;
      this.editValue = null;
    },
    saveEdit(index, tessera) {
      this.chiamataAxios("PATCH", "/auth/tesseramenti/changeTesseraNumber", {
        dialogLoader: true,
        body: {
          masterId: tessera.masterId,
          stagione: tessera.stagione,
          asdCode: tessera.asdCode,
          asdTesId: tessera.asdTesId,
          dateTes: tessera.dateTes,
          asdTesNum: this.editValue,
        },
      }).then((response) => {
        if (response.msg.esito) tessera.asdTesNum = this.editValue;
        this.editingIndex = null;
        this.editValue = null;
      });
    },
  },
};
</script>

<style scoped>
.tessera-number-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  white-space: nowrap;
}

.tessera-number {
  font-size: 18px;
}
</style>